import Vue from "vue";
import MyTable from "@/components/MyTable.vue";
import MyFromFilter from "@/components/MyFromFilter.vue";
import DetailCom from "@/components/DetailCom.vue";

Vue.component('MyTable',MyTable)
Vue.component('MyFromFilter',MyFromFilter )

Vue.component('DetailCom',DetailCom)


// WEBPACK FOOTER //
// ./src/components/index.js